import { pwgen } from './functions/pwgen';
import { transliterate } from "./functions/transliterate";

export default {
    install: function (Vue, args = {}) {
        Vue.prototype.$helper = {
            pwgen,
            transliterate,
            openHref(href) {
                window.open(href, "_blank");
            },
        };
    }
}
